import { createContext } from 'react';

export const ExpensesprodContext = createContext<any>({});

export default ExpensesprodContext;
